<script>

import axios from "axios";
import Swal from "sweetalert2";
import { Toast } from "@/state/helpers";
import { toast, variants } from "@/helpers/toaster";

export default {
  page: {
    title: "Profile",
  },
  components: {
  },
  data() {
    return {
      isPasswordResetting: false,
      accountForm: {
        fields: {
          email: {
            value: '',
            error: false,
          },
          current_password: {
            value: '',
            error: false,
          },
          new_password: {
            value: '',
            error: false,
          },
          password_confirmation: {
            value: '',
            error: false,
          },
        }
      },
    };
  },

  computed: {
    user() {
      return this.$store.state.user.user;
    },
    account() {
      return this.$store.state.user.account;
    },
    qrCode () {
      return this.$store.state.user.user.qr_code;
    },
    recoveryCode () {
      return this.$store.state.user.user.two_factor_recovery_codes;
    }
  },
  created() {
    this.initializeFieldsFromState();
  },
  methods: {
    initializeFieldsFromState() {
      this.accountForm.fields.email.value = this.account.email;
      this.isPasswordResetting = false;
      this.accountForm.fields.current_password.value = '';
      this.accountForm.fields.new_password.value = '';
      this.accountForm.fields.password_confirmation.value = '';
    },
    async complete () {
      this.validateForm();

      try{
        const newData = {
          email: this.accountForm.fields.email.value,
        }
        if (this.isPasswordResetting) {
          newData.current_password = this.accountForm.fields.current_password.value;
          newData.password = this.accountForm.fields.new_password.value;
          newData.password_confirmation = this.accountForm.fields.password_confirmation.value;
        }
        await this.$store.dispatch('user/updateAccount', newData);
        toast('Uspešna izmena lozinke.', variants.SUCCESS)
        this.$emit('accountDataUpdate', newData)
      } catch (error) {
        // eslint-disable-next-line no-empty
      }

    },
    cancel() {
      this.initializeFieldsFromState();
      this.$emit('a ccountDataUpdateCancel')
    },
    validateForm() {
      let isValid = true;
      let fields = [this.accountForm.fields.email];

      if (this.isPasswordResetting) {
        fields.push(this.accountForm.fields.current_password)
        fields.push(this.accountForm.fields.new_password)
        fields.push(this.accountForm.fields.password_confirmation)
      }

      for (let field in fields) {
        // check if field is empty
        if(fields[field].value === '' || fields[field].value === null) {
          fields[field].error = true;
          isValid = false;
        }
      }

      if (this.isPasswordResetting &&
          this.accountForm.fields.new_password.value !== this.accountForm.fields.password_confirmation.value) {

        this.accountForm.fields.new_password.error = true;
        this.accountForm.fields.password_confirmation.error = true;
        isValid = false;
      }

      return isValid;
    },
    async deleteAccount() {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "error",
        showCancelButton: true,
        confirmButtonColor: "#f46a6a",
        cancelButtonColor: "#868585",
        confirmButtonText: "Delete account!"
      })
      if (result.value) {
        this.$store.commit('loader/START_LOADING');
        try {
          await axios.delete(`/user`);
          await axios.post(`/logout`);
          this.$store.commit('auth/LOG_OUT');
          await this.$router.push('/login');
        } finally {
          this.$store.commit('loader/END_LOADING');
        }
      }
    },
    async enable2FA () {
      if (await this.confirmModal('enable')) {
        try {
          this.$store.commit('loader/START_LOADING');
          await axios.post(`/user/two-factor-authentication`);
          this.showSuccessNotification('disable');
          this.$store.dispatch('user/getUserData');
        } finally {
          this.$store.commit('loader/END_LOADING');
        }
      }
    },
    async disable2FA () {
      if (await this.confirmModal('disable')) {
        try {
          this.$store.commit('loader/START_LOADING');
          await axios.delete(`/user/two-factor-authentication`);
          this.showSuccessNotification('disable');
          this.$store.dispatch('user/getUserData');
        } finally {
          this.$store.commit('loader/END_LOADING');
        }
      }
    },
    showSuccessNotification (type) {
      Toast.fire({
        title: `2 Factor Auth ${type}d successfully.`,
        icon: "success",
      });
    },
    async confirmModal (type) {
      const result = await Swal.fire({
        title: `Are you sure you want to ${type} two factor authentication?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#01baf1",
        cancelButtonColor: "#868585",
        confirmButtonText: `Yes, ${type}.`
      });

      return result.value;
    }
  }
};
</script>

<template>
  <div>
    <form ref="accountForm" autocomplete="off" @submit.prevent="complete">
      <div class="form-group row mb-3">
        <label class="col-12 col-md-5 col-form-label" for="email">Email:</label>
        <div class="col-12 col-md-7">
          <input
              id="email"
              type="email"
              autocomplete="off"
              disabled
              class="form-control"
              @input="accountForm.fields.email.error = false"
              :class="{'is-invalid': accountForm.fields.email.error}"
              name="email"
              v-model="accountForm.fields.email.value"
          />
        </div>
      </div>

      <button type="button" class="btn btn-link p-0 mb-3" @click="isPasswordResetting = !isPasswordResetting">
        <span v-if="!isPasswordResetting">
          Izmeni lozinku
        </span>
        <span v-else>
          Otkaži izmenu lozinke
        </span>
      </button>

      <div v-if="isPasswordResetting">
        <div class="form-group row mb-3">
          <label class="col-12 col-md-5 col-form-label" for="current_password">Lozinka:</label>
          <div class="col-12 col-md-7">
            <input
                id="current_password"
                type="password"
                autocomplete="new-password"
                class="form-control"
                @input="accountForm.fields.current_password.error = false"
                :class="{'is-invalid': accountForm.fields.current_password.error}"
                name="current_password"
                v-model="accountForm.fields.current_password.value"
            />
          </div>
        </div>

        <div class="form-group row mb-3">
          <label class="col-12 col-md-5 col-form-label" for="new_password">Nova lozinka:</label>
          <div class="col-12 col-md-7">
            <input
                id="new_password"
                type="password"
                autocomplete="new-password"
                class="form-control"
                @input="accountForm.fields.new_password.error = false"
                :class="{'is-invalid': accountForm.fields.new_password.error}"
                name="new_password"
                v-model="accountForm.fields.new_password.value"
            />
          </div>
        </div>

        <div class="form-group row mb-3">
          <label class="col-12 col-md-5 col-form-label" for="password_confirmation">Ponovi novu lozinku:</label>
          <div class="col-12 col-md-7">
            <input
                id="password_confirmation"
                type="password"
                autocomplete="new-password"
                class="form-control"
                @input="accountForm.fields.password_confirmation.error = false"
                :class="{'is-invalid': accountForm.fields.password_confirmation.error}"
                name="current_password"
                v-model="accountForm.fields.password_confirmation.value"
            />
          </div>
        </div>
      </div>
<!-- 
      <button v-if="qrCode" type="button" class="btn d-block btn-danger mb-3" @click="disable2FA">
          Disable 2FA
      </button>
      <button v-else type="button" class="btn  d-block btn-primary mb-3" @click="enable2FA">
          Enable 2FA
      </button> -->

      <div v-if="qrCode">
        <h3>You have enabled two factor authentication.</h3>
        <p>
          When two factor  authentication is enabled, you will be prompted for a secure, random token during authentication.
        </p>
        <p>
          Two factor authentication is now enabled. Scan he folowing QR code using your phones's authenticator application.
        </p>
        <div class="qr-code">
          <div v-html="qrCode"></div>
        </div>
        <p>
          Store these recovery codes in a secure password manager.
          They can be used to recover access to our account of your two factor
          authentication device is lost.
        </p>
        <div class="recovery-codes">
          <span v-for="codeLine in recoveryCode" :key="codeLine" class="recovery-code-line">{{ codeLine }}</span>
        </div>
      </div>

      <div class="mt-4 d-block d-sm-flex justify-content-between">
        <div class="text-left">
          <!-- <button type="button" class="btn btn-link btn-sm text-danger mr-3 p-0" @click="deleteAccount">
            Delete account
          </button> -->
        </div>

        <div class="text-right ">
          <b-button type="button" variant="secondary" @click="cancel()">Otkaži</b-button>
          <b-button type="submit" variant="primary" class="ml-2" >Snimi</b-button>
        </div>
      </div>
    </form>
  </div>
</template>

<style>
  .recovery-codes {
    padding: 1rem;
    background-color: #f1f0f5;
    border-radius: 5px;
    border: 1px solid #c5cbd1;
  }

  .recovery-code-line {
    display: block;
    margin-bottom: 0.3rem;
  }

  .qr-code {
    margin-bottom: 1rem;
  }
</style>
